import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NAV_ITEMS = [
  { path: '/', label: 'Dashboard', icon: '\u{1F4CA}' },
  { path: '/campaigns', label: 'Campanas', icon: '\u{1F4E2}' },
  { path: '/contacts', label: 'Contactos', icon: '\u{1F4CB}' },
  { path: '/contact-lists', label: 'Listas', icon: '\u{1F4C1}' },
  { path: '/abandoned-carts', label: 'Carritos', icon: '\u{1F6D2}' },
  { path: '/settings', label: 'Config', icon: '\u{2699}\u{FE0F}' },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar */}
      <nav style={{
        width: 220, background: '#1a1a2e', color: '#fff', padding: '20px 0',
        display: 'flex', flexDirection: 'column',
      }}>
        <div style={{ padding: '0 20px 20px', borderBottom: '1px solid #333', marginBottom: 10 }}>
          <h2 style={{ margin: 0, fontSize: 16 }}>WhatsApp Campaigns</h2>
          <small style={{ color: '#aaa' }}>{user?.nombre}</small>
        </div>
        {NAV_ITEMS.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '12px 20px', color: location.pathname === item.path ? '#4ecca3' : '#ccc',
              textDecoration: 'none', fontSize: 14,
              background: location.pathname === item.path ? 'rgba(78,204,163,0.1)' : 'transparent',
            }}
          >
            <span>{item.icon}</span> {item.label}
          </Link>
        ))}
        <div style={{ marginTop: 'auto', padding: '20px' }}>
          <button onClick={logout} style={{
            width: '100%', padding: '8px', background: '#e74c3c', color: '#fff',
            border: 'none', borderRadius: 4, cursor: 'pointer',
          }}>
            Cerrar Sesion
          </button>
        </div>
      </nav>

      {/* Main content */}
      <main style={{ flex: 1, padding: 30, background: '#f5f6fa', overflowY: 'auto' }}>
        {children}
      </main>
    </div>
  );
}
